import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Buefy from 'buefy'
import './assets/bulma.scss'
import VueFlags from "@growthbunker/vueflags";
import VueCookie from 'vue-cookie'
Vue.config.productionTip = false

Vue.use(Buefy);
Vue.use(VueFlags);
Vue.use(VueCookie);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')